export default __webpack_public_path__ + "static/media/store.43ae18e1.svg";